/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { RuiStore } from "@anvilor/ngx-rui";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { ThemeService } from "@anvilor/ngx-theming";
import { DefaultMediaObserver } from "@anvilor/ngx-apps-core";
import { ASSET_ANVILOR_SOLID_ICON } from "../../config/theme-config";

@Component({
  selector: "app-survey-footer-control",
  template: ` <div class="nvt-bar-2 mat-elevation-z2" id="footer">
    <div class="fxr-c-c">
      <a href="https://anvilorsolutions.com" class="powered-by fxr-s-c">
        <img
          class="gfx anvilor-footer-icon"
          [src]="anvilorIconPath$ | async"
          alt="Anvilor Icon"
        />
        <i>Powered by Anvilor&trade;</i>
      </a>
    </div>
  </div>`,
  styleUrls: ["./survey-footer-control.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SurveyFooterControlComponent {
  anvilorIconPath$: Observable<string>;

  constructor(
    private store: RuiStore,
    private theme: ThemeService,
    public media: DefaultMediaObserver
  ) {
    this.anvilorIconPath$ = theme.selectAssetPath(ASSET_ANVILOR_SOLID_ICON);
  }
}
